import React, {Component} from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import InnerLoader from './../../APP/COMPONENTS/InnerLoader';
import * as helpers from "./../../APP/HELPERS/functions"

function mapStateToProps(state) {
    return {};
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class LoginForm extends Component {

    /// CONSTRUCTOR ///
    constructor(props)
    {
        super(props);

        this.state = {
            SENDING: false,
            EMAIL: '',
            PASSWORD: '',
            VIEW: 'login'
        };
    }

    componentDidMount()
    {
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
    }

    recordData = (input, type) => 
    {
        this.setState({[type]: input.target.value});
    }

    renderLoginButton()
    {
        if (this.isReadyToLogin()) {
            if (this.state.SENDING) {
                return <button className="default">Входим ...</button>;
            } else {
                return <button className="default" onClick={() => this.login()}>Войти</button>;
            }
        } else {
            return <button className="default inactive">Войти</button>
        }
    }

    renderRecoverButton()
    {
        if (this.isReadyToRecover()) {
            if (this.state.SENDING) {
                return <button className="default">Восстанавливаем ...</button>;
            } else {
                return <button className="default" onClick={() => this.recover()}>Восстановить</button>;
            }
        } else {
            return <button className="default inactive">Восстановить</button>
        }
    }

    isReadyToRecover = () =>
    {
        if (this.validateEmail(this.state.EMAIL)) {
            return true;
        }

        return false;
    }

    isReadyToLogin = () =>
    {
        if (this.validateEmail(this.state.EMAIL) && (this.state.PASSWORD.length > 3)) {
            return true;
        }

        return false;
    }

    validateEmail = (email) =>
    {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    login = async () =>
    {
        if (!this.state.SENDING) {
            try {
                this.setState({SENDING: true});

                let SEND_DATA = {
                    action:     'supplierLogin',
                    email:      this.state.EMAIL,
                    password:   this.state.PASSWORD
                };

                let data = await Request(SEND_DATA,CONFIG.API_GATE);
                if (data !== false) {
                    this.props.doAuth(data.supplier);
                    this.props.openLogin(false)
                    this.setState({SENDING: false});
                } else {
                    this.setState({SENDING: false});
                }
            } catch (error) {
                this.setState({SENDING: false});
            }
        }
    }

    recover = async () =>
    {
        if (!this.state.SENDING) {
            try {
                this.setState({SENDING: true});

                let SEND_DATA = {
                    action:     'supplierRecover',
                    email:      this.state.EMAIL
                };

                let data = await Request(SEND_DATA,CONFIG.API_GATE);
                if (data !== false) {
                    this.setState({VIEW: 'login', SENDING: false});
                } else {
                    this.setState({SENDING: false});
                }
            } catch (error) {
                this.setState({SENDING: false});
            }
        }
    }

    renderForm = () =>
    {
        if (this.state.VIEW == 'login') {
            return (
                <div>
                    <div className="login_head">
                        Авторизация
                    </div>

                    <div className="login_form">
                        <input 
                            placeholder="Электронная почта"
                            type="email"
                            onChange={(text) => this.recordData(text, 'EMAIL')} 
                        />
                        <input 
                            placeholder="Пароль"
                            type="password"
                            onChange={(text) => this.recordData(text, 'PASSWORD')} 
                        />

                        {this.renderLoginButton()}

                        <a className="recover_button" onClick={() => this.setState({VIEW: 'recover'})}>
                            Восстановить пароль
                        </a>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="login_head">
                        Восстановление пароля
                    </div>

                    <div className="login_form">
                        <input 
                            placeholder="Электронная почта"
                            type="email"
                            onChange={(text) => this.recordData(text, 'EMAIL')} 
                        />

                        {this.renderRecoverButton()}

                        <a className="recover_button" onClick={() => this.setState({VIEW: 'login'})}>
                            К авторизации
                        </a>
                    </div>
                </div>
            );
        }
    }

    render()
    {
        return (
            <div className="modal-content">
                <div className="login_first_row">
                    <img src="/system_images/logo_orange.png" />
                    <div className="login_first_text_holder">
                        <div>Ecomarket.ru</div>
                        <div>поставщики</div>
                    </div>
                </div>

                {this.renderForm()}
            </div>
        );
    }

}

export default connect(
    mapStateToProps, mapDispatchToProps
)(LoginForm);